export default function toQueryString(obj) {
  return Object.keys(obj).reduce((a, k) => {
    if (obj[k] !== undefined) {
      a.push(`${k}=${encodeURIComponent(obj[k])}`);
    }
    return a;
  }, []).join('&');
}
